import { render, staticRenderFns } from "./Treasure.vue?vue&type=template&id=3dd74b10&scoped=true"
import script from "./Treasure.vue?vue&type=script&lang=js"
export * from "./Treasure.vue?vue&type=script&lang=js"
import style0 from "./Treasure.vue?vue&type=style&index=0&id=3dd74b10&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dd74b10",
  null
  
)

export default component.exports